module.exports = __webpack_public_path__ + "img/newRetail-worry-cent.b652bc7b.png";